import Vue from 'vue'
import Router from 'vue-router'
// Containers
import Full from '@/containers/Full'
// Views
import dashboard from '@/views/components/dashboard'
import Merchantdashboard from '@/views/merchantdashboard'
import Charts from '@/views/Charts'
import Widgets from '@/views/Widgets'
// Views - Components
import Buttons from '@/views/components/Buttons'
import SocialButtons from '@/views/components/SocialButtons'
import Cards from '@/views/components/Cards'
import Forms from '@/views/components/Forms'
import Modals from '@/views/components/Modals'
import Switches from '@/views/components/Switches'
import Tables from '@/views/components/Tables'
// import test from '@/views/test'
import CryptoJS from 'crypto-js';
import FontAwesome from '@/views/icons/FontAwesome'
import SimpleLineIcons from '@/views/icons/SimpleLineIcons'
// Views - Pages
import Page404 from '@/views/pages/Page404'
import Page500 from '@/views/pages/Page500'
import Login from '@/views/components/login'
import Register from '@/views/pages/Register'

// import connectionhubs from '@/views/components/connectionhub'
import Pagination from '@/views/components/pagination'
import Import from '@/views/components/import'
import ShipmentRuleDetails from '@/views/components/ShipmentRuleDetails'
// import HubDetails from '@/views/components/HubDetails'
import AllocateShipmentRuleToClient from '@/views/components/AllocateShipmentRuleToClient'
import BulkAllocateShipmentRuleToClient from '@/views/components/BulkAllocateShipmentRuleToClient'
import DynamicBagging from '@/views/components/DynamicBagging'
import changepassword from '@/views/components/changepassword'
import group from '@/views/components/group'
import groupWiseHubs from '@/views/components/group/groupWiseHubs'
import groupConnectinWiseHubs from '@/views/components/group/groupConnectinWiseHubs'

import createGroupDestination from '@/views/components/group/creategroup'
import mapGroupConnection from '@/views/components/group/groupmapping'
import locationSearch from '@/views/components/group/locationsearch'
import addLocationToGroup from '@/views/components/group/addlocationtogroup'

import bagdetails from '@/views/components/BagDetails'
import shipmentsummary from '@/views/components/ShipmentSummary'
import confirmlinehaulconnection from '@/views/components/ConfirmLineHaulConnection'
import ConnectionHubDetailsRouteMode from '@/views/components/ConnectionHubDetailsRouteMode'
import VehicleTripSummary from '@/views/components/VehicleTripSummary'
import BagDetailsInvoice from '@/views/components/BagDetailsInvoice'
import ShiftConnectionLHCO from '@/views/components/ShiftConnectionLHCO'
import hubMachineConfiguration from '@/views/components/hubMachineConfiguration'
import LineHaulPrint from '@/views/components/LineHaulPrint'
import TripSheetPrint from '@/views/components/TripSheetPrint'
import StopPointHubAllocationMapping from '@/views/components/StopPointHubAllocationMapping'
import BagStickerPrint from '@/views/components/BagStickerPrint'
import TripGenerateConnectionPrint from '@/views/components/TripGenerateConnectionPrint'
//import AllocateHubToTouchPoint from '@/views/components/AllocateHubToTouchPoint'
// import DWSInscan from '@/views/components/DWSInscan'
import GenerateVehicleTripPrint from '@/views/components/GenerateVehicleTripPrint'
import LogDetails from '@/views/components/LogDetails'
import CenterScanInTrip from '@/views/components/CenterScanInTrip'
import BagOutShipment from '@/views/components/BagOutShipment'
import BaginProcess from '@/views/components/BaginProcess'
import NetworkManagement from '@/views/components/NetworkManagement'
import GenerateTripSheet from '@/views/components/NetworkManagement/GenerateTripSheet'

import CenterScanOut from '@/views/components/CenterScanOut'
import Allocation from '@/views/components/Allocation'
import HubInscan from '@/views/components/HubInscan'

import Sorter from '@/views/components/Sorter'
import Changehub from '@/views/components/changehub'
import InscanOverageShortage from '@/views/components/InscanOverageShortage'
import MarkBagInvalid from '@/views/components/MarkBagInvalid'
import RouteModeChangeRequest from '@/views/components/RouteModeChangeRequest'
import CwbHoldRequest from '@/views/components/CwbHoldRequest'
import CwbHoldRequestToDo from '@/views/components/CwbHoldRequestToDo'
import HoldCapacityConfig from '@/views/components/HoldCapacityConfig'
import CwbHoldBagsReport from '@/views/components/CwbHoldBagsReport'
import RouteModeChangeApproval from '@/views/components/RouteModeChangeApproval'
import BagShipmentQuery from '@/views/components/BagShipmentQuery'
import SRTripDayClosure from '@/views/components/SRTripDayClosure'
import MarkHubStressed from '@/views/components/MarkHubStressed'
import TransactionalLogs from '@/views/components/TransactionalLogs'
import LineHaulStatusCode from '@/views/components/LineHaulStatusCode'
import MissingShipmentLogReconcile from '@/views/components/MissingShipmentLogReconcile'
import SurfaceCargoMapping from '@/views/components/SurfaceCargoMapping'
import changeBagSeal from '@/views/components/changeBagSeal'
import TripManagement from '@/views/components/TripManagement'
import combohub from '@/views/components/combohub'
import ComboHubBagShortageMark from '@/views/components/ComboHubBagShortageMark'
import combohubconfiguration from '@/views/components/combohubconfiguration'
import MarkShipmentShortage from '@/views/components/MarkShipmentShortage'
import RVPLabel from '@/views/components/RVPLabel'
import AllocateActiveHub from '@/views/components/AllocateActiveHub'
import ProcesscodeGeneration from '@/views/components/ProcesscodeGeneration'
import BagDetailsByHub from '@/views/components/BagDetailsByHub'
import AutoBagOutHubConfiguration from '@/views/components/AutoBagOutHubConfiguration'
import InscanNTSShipment from '@/views/components/InscanNTSShipment'
import FetchConnectionDetails from '@/views/components/FetchConnectionDetails'
import OffloadShipment from '@/views/components/OffloadShipment'
import THCQuerySummary from '@/views/components/THCQuerySummary'
import DTOProcessingHubDetails from '@/views/components/DTOProcessingHubDetails'
import locationMaster from '@/views/components/locationMaster'
import rackMaster from '@/views/components/rackMaster'
import palletMaster from '@/views/components/palletMaster'
import rowMaster from '@/views/components/rowMaster'
import binsMaster from '@/views/components/binsMaster'
import pushNDCDetails from '@/views/components/pushNDCDetails'
import AWBVerification from '@/views/components/AWBVerification'
import AWBVerificationMapping from '@/views/components/AWBVerificationMapping'
import CloseBin from '@/views/components/CloseBin'
import ScanToBagReport from '@/views/components/ScanToBagReport'
import bagAndShipmentStatusReport from '@/views/components/bagAndShipmentStatusReport'
import unlinkMultiPartGrpId from '@/views/components/unlinkMultiPartGrpId'
import mergeConnectionSchedule from '@/views/components/MergeConnectionSchedule'
import generateBagOctroilListPrint from '@/views/components/generateBagOctroilListPrint'
import ScanToBagActiveBinReport from '@/views/components/ScanToBagActiveBinReport'
import DelhiSorter from '@/views/components/DelhiSorter'
import PalletReportPages from '@/views/components/PalletReportPages'
import PTLMapping from '@/views/components/PTLMapping'
import InscanDoneBagInPendingReport from '@/views/components/InscanDoneBagInPendingReport'
import BinSticker from '@/views/components/BinSticker'
import PTLMappingList from '@/views/components/PTLMappingList'
import BhiwandiSorter from '@/views/components/BhiwandiSorter'
import SorterImageDownload from '@/views/components/SorterImageDownload'
import TripSheetPrintFromCurrentTP from '@/views/components/TripSheetPrintFromCurrentTP'
import TripSheetPrintForBulkFromCurrentTP from '@/views/components/TripSheetPrintForBulkFromCurrentTP'
import SorterBatchStatus from '@/views/components/SorterBatchStatus'
import DWSInscanNew from '@/views/components/DWSInscanNew'
import ShipmentClientRule from '@/views/components/ShipmentClientRule'
import bangloreCBS from '@/views/components/bangloreCBS'
//import RVPPrintLabel from '@/views/components/RVPPrintLabel'
import UnboxSurat from '@/views/components/UnboxSurat'
import RTODTOLabel from '@/views/components/RTODTOLabel'
import RTODTOStickerTracking from '@/views/components/RTODTOStickerTracking'
import SuratCBS from '@/views/components/SuratCBS'
import Hub_Details from '@/views/components/Hub_Details'
import PushCenterCode from '@/views/components/PushCenterCode'
import EbnShipmentDetails from '@/views/components/EBNShipmentDetails'
//import connectionhubfornetwork from '@/views/components/connectionhubfornetwork'
//import AllocateHubToTouchPointForNetwork from '@/views/components/AllocateHubToTouchPointForNetwork'
import PushBaginRule from '@/views/components/PushBaginRule'
import connectionhubfornetworknew from '@/views/components/connectionhubfornetworknew'
import AllocateHubToTouchPointForNetworkNew from '@/views/components/AllocateHubToTouchPointForNetworkNew'
import ChennaiSorter from '@/views/components/ChennaiSorter'
import SorterShipmentTracking from '@/views/components/SorterShipmentTracking'
import AWBVerificationDimWt from '@/views/components/AWBVerificationDimWt'
import AWBPendingVerification from '@/views/components/AWBPendingVerification'
import setbaggingpattern from '@/views/components/setbaggingpattern'
import hubparentbagginghubdetails from '@/views/components/hubparentbagginghubdetails'
import rtobagginghubdetails from '@/views/components/rtobagginghubdetails'
import connectionhubsnew from '@/views/components/connectionhubnew'
import BulkInscanOverageShipment from '@/views/components/BulkInscanOverageShipment'
import LineHaulMaster from '@/views/components/LineHaulMaster'
import EmployeeMaster from '@/views/components/EmployeeMaster'
import DlinkReport from '@/views/components/DlinkReport'
import ThermalPrinterAllocation from '@/views/components/ThermalPrinterAllocation'
import BaginProcessWithRedis from '@/views/components/BaginProcessWithRedis'
import ArmstrongCBS from '@/views/components/ArmstrongCBS'
import DNFShipmentReport from '@/views/components/DNFShipmentReport'
import PushShipmentDetails from '@/views/components/PushShipmentDetails'
//import HubTempInscanRestricting from '@/views/components/HubTempInscanRestricting'
import VehicleTripSummaryV1 from '@/views/components/VehicleTripSummaryV1'
import TripSheetPrintV1 from '@/views/components/TripSheetPrintV1'
import TripSheetPrintFromCurrentTPV1 from '@/views/components/TripSheetPrintFromCurrentTPV1'
import TripSheetPrintForBulkFromCurrentTPV1 from '@/views/components/TripSheetPrintForBulkFromCurrentTPV1'
import CenterScanInTrip_v1 from '@/views/components/CenterScanInTrip_v1'
import MandatoryWeighingEventConfig from '@/views/components/MandatoryWeighingEventConfig'
import RestrictTempInscanOnHub from '@/views/components/RestrictTempInscanOnHub'
import ExportRestrictTempInscanMapping from '@/views/components/ExportRestrictTempInscanMapping'
import AWBVerificationDimWt_v1 from '@/views/components/AWBVerificationDimWt_v1'
import AutoHandover from '@/views/components/AutoHandover'
import SorterSQSDetails from '@/views/components/SorterSQSDetails'
import FalconSorter from '@/views/components/FalconSorter'
import RtoShipmentPageDashboard from '@/views/components/RtoShipmentPageDashboard'
import AutoHandover_v1 from '@/views/components/AutoHandover_v1'
import PalletizationMasters from '@/views/components/Palletization/Masters'
import PalletizationReports from '@/views/components/Palletization/Reports'
import PalletizationBarcode from '@/views/components/Palletization/Barcode'
import BagSorter from '@/views/components/BagSorter'
import AutoHandoverBarcode from '@/views/components/AutoHandoverBarcode'
import DirectBagging from '@/views/components/DirectBagging'
import SorterHandover from '@/views/components/SorterHandover'
import SectorMapping from '@/views/components/SectorMapping'
import KengicSorter from '@/views/components/KengicSorter'
import DTOstickering from '@/views/components/DTOstickering'
import AutoHandoverReports from '@/views/components/AutoHandoverReports'
import AutoHandoverBatchDetailsPrint from '@/views/components/AutoHandoverBatchDetailsPrint'
import SorterConfig from '@/views/components/SorterConfig'
import TrolleyConfig from '@/views/components/TrolleyConfig'
import groupdestinationsearch from '@/views/components/groupnew/DestinationSearch'
import groupnew from '@/views/components/groupnew'
import VehicleSealInScan from '@/views/components/VehicleSealInScan'
import SorterBagging from '@/views/components/SorterBagging'
import RTODTOLabelNew from '@/views/components/RTODTOLabelNew'

import Downloads3bucketfiles from '@/views/components/Downloads3bucketfiles'
import MarkBulkBagShortage from '@/views/components/MarkBulkBagShortage'
import PrintForwardSticker from '@/views/components/PrintForwardSticker'
import AutoBagOutConfiguration_v1 from '@/views/components/AutoBagOutConfiguration_v1'
import AddDamageByOperation from '@/views/components/AddDamageByOperation'
import OverageApprovalPanel from '@/views/components/OverageApprovalPanel'
import ShortageApprovalPanel from '@/views/components/ShortageApprovalPanel'
import DTOAWBFlyerCheck from '@/views/components/DTOAWBFlyerCheck'
import SorterPrintSticker from '@/views/components/SorterPrintSticker'
import AdditionalEventLogs from '@/views/components/AdditionalEventLogs' 
import BulkUploadSecondarySortConfiguration from '@/views/components/BulkUploadSecondarySortConfiguration'
import DirectToBag from '@/views/components/DirectToBag'
import PickUPCenterConfig from '@/views/components/PickUPCenterConfig'
import FacilityConfig from '@/views/components/FacilityConfig'
import ReleasePrinter from '@/views/components/ReleasePrinter'
import InboundMandate from '../views/components/InboundMandate'
import FmBagHandover from '@/views/components/FmBagHandover'
import RedisDashboard from '@/views/components/RedisDashboard'
import ProductivityTracking from '@/views/components/ProductivityTracking'
import CameraMaster from '@/views/components/CameraMaster'
import DockMaster from '@/views/components/DockMaster'
import ManualDockOut from '@/views/components/ManualDockOut'
import NtcMappingMaster from '@/views/components/NtcMappingMaster'
import NtcSectorMapping from '@/views/components/NtcSectorMapping'
import LmParentMapping from '@/views/components/LmParentMapping'
import ParentHubCWBReport from '@/views/components/ParentHubCWBReport'


Vue.use(Router)
const router = new Router({
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({
    y: 0
  }),
  routes: [{
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: Full,
      children: [{
          path: 'dashboard',
          name: 'dashboard',
          component: dashboard,
          meta: {
            requiresAuth: true,
            link: '/dashboard'
          },
        },

        {
          path: 'pagination',
          name: 'Pagination',
          component: Pagination,
          meta: {
            requiresAuth: true,
            breadcrumb: [{
                name: 'Home',
                link: '/pagination'
              },
              {
                name: 'Pagination'
              }
            ]
          }
        },
        {
          path: '/Changehub',
          name: 'Changehub',
          component: Changehub,
          meta: {
            requiresAuth: true,
            link: '/changehub'
          }
        },
        {
          path: '/MarkBagInvalid',
          name: 'MarkBagInvalid',
          component: MarkBagInvalid,
          meta: {
            requiresAuth: true,
            link: '/MarkBagInvalid'
          }
        },
        {
          path: '/RouteModeChangeApproval',
          name: 'RouteModeChangeApproval',
          component: RouteModeChangeApproval,
          meta: {
            requiresAuth: true,
            link: '/RouteModeChangeApproval'
          }
        },
        {
          path: '/RouteModeChangeRequest',
          name: 'RouteModeChangeRequest',
          component: RouteModeChangeRequest,
          meta: {
            requiresAuth: true,
            link: '/RouteModeChangeRequest'
          }
        },
        {
          path: '/CwbHoldRequest',
          name: 'CwbHoldRequest',
          component: CwbHoldRequest,
          meta: {
            requiresAuth: true,
            link: '/CwbHoldRequest'
          }
        },
        {
          path: '/CwbHoldRequestToDo',
          name: 'CwbHoldRequestToDo',
          component: CwbHoldRequestToDo,
          meta: {
            requiresAuth: true,
            // HUB-8238: reuse CwbHoldRequest menu permission until UMS adds /CwbHoldRequestToDo.
            link: '/CwbHoldRequest'
          }
        },
        {
          path: '/CwbHoldBagsReport',
          name: 'CwbHoldBagsReport',
          component: CwbHoldBagsReport,
          meta: {
            requiresAuth: true,
            link: '/CwbHoldBagsReport',
          },
        },
        {
          path: '/HoldCapacityConfig',
          name: 'HoldCapacityConfig',
          component: HoldCapacityConfig,
          meta: {
            requiresAuth: true,
            link: '/HoldCapacityConfig'
          }
        },
        {
          path: '/Hub_Details',
          name: 'Hub_Details',
          component: Hub_Details,
          meta: {
            requiresAuth: true,
            link: '/dashboard'
          }
        },
        {
          path: '/RtoShipmentPageDashboard',
          name: 'RtoShipmentPageDashboard',
          component: RtoShipmentPageDashboard,
          meta: {
            requiresAuth: true,
            link: '/dashboard'
          }
        },
         {
        path: '/FmBagHandover',
        name: 'FmBagHandover',
        component: FmBagHandover,
        meta: {
          requiresAuth: true,
          link: '/dashboard'
        }
      },
        {
          path: '/ParentHubCWBReport',
          name: 'ParentHubCWBReport',
          component: ParentHubCWBReport,
          meta: {
            requiresAuth: true,
            link: '/ParentHubCWBReport'
          }
        },
        {
          path: '/group',
          name: 'group',
          component: group,
          meta: {
            requiresAuth: true,
            link: '/group'
          }
        },
        {
          path: '/createGroupDestination',
          name: 'createGroupDestination',
          component: createGroupDestination,
          meta: {
            requiresAuth: true,
            link: '/dashboard'
          }
        },
        {
          path: '/BulkInscanOverageShipment',
          name: 'BulkInscanOverageShipment',
          component: BulkInscanOverageShipment,
          meta: {
            requiresAuth: true,
            link: '/BulkInscanOverageShipment'
          }
        },
        {
          path: '/DirectBagging',
          name: 'DirectBagging',
          component: DirectBagging,
          meta: {
            requiresAuth: true,
            link: '/dashboard'
          }
        },
        {
          path: '/OverageApprovalPanel',
          name: 'OverageApprovalPanel',
          component: OverageApprovalPanel,
          meta: {
            requiresAuth: true,
            link: '/OverageApprovalPanel'
          }
        },
        {
          path: '/ShortageApprovalPanel',
          name: 'ShortageApprovalPanel',
          component: ShortageApprovalPanel,
          meta: {
            requiresAuth: true,
            link: '/ShortageApprovalPanel'
          }
        },
        {
          path: '/mapGroupConnection',
          name: 'mapGroupConnection',
          component: mapGroupConnection,
          meta: {
            requiresAuth: true,
            link: '/mapGroupConnection'
          }
        },
        {
          path: '/locationSearch',
          name: 'locationSearch',
          component: locationSearch,
          meta: {
            requiresAuth: true,
            link: '/dashboard'
          }
        },
        {
          path: '/addLocationToGroup',
          name: 'addLocationToGroup',
          component: addLocationToGroup,
          meta: {
            requiresAuth: true,
            link: '/dashboard'
          }
        },
        {
          path: '/groupWiseHubs/:grouptemplateId',
          name: 'groupWiseHubs',
          component: groupWiseHubs,
        },
        {
          path: '/groupConnectinWiseHubs/:grouptemplateId',
          name: 'groupConnectinWiseHubs',
          component: groupConnectinWiseHubs,
        },
        {
          path: '/connectionhubs',
          name: 'connectionhubs',
          component: connectionhubsnew,
          meta: {
            requiresAuth: true,
            link: '/connectionhubs'
          }
        },
        // {
        //   path: '/connectionhubsnew',
        //   name: 'connectionhubsnew',
        //   component: connectionhubsnew,
        //   meta: {
        //     requiresAuth: true,
        //     link: '/dashboard'
        //   }
        // },
        {
          path: '/setbaggingpattern',
          name: 'setbaggingpattern',
          component: setbaggingpattern,
          meta: {
            requiresAuth: true,
            link: '/setbaggingpattern'
          }
        },
        {
          path: '/DynamicBagging',
          name: 'DynamicBagging',
          component: DynamicBagging,
          meta: {
            requiresAuth: true,
            link: '/DynamicBagging'
          }
        },
        {
          path: '/bagdetails',
          name: 'bagdetails',
          component: bagdetails,
          meta: {
            requiresAuth: true,
            link: '/bagdetails'
          }
        },
        {
          path: '/ThermalPrinterAllocation',
          name: 'ThermalPrinterAllocation',
          component: ThermalPrinterAllocation,
          meta: {
            requiresAuth: true,
            link: '/dashboard'
          }
        },
        {
          path: '/AutoHandover',
          name: 'AutoHandover',
          component: AutoHandover,
          meta: {
            requiresAuth: true,
            link: '/dashboard'
          }
        },
        {
          path: '/Facility_Config',
          name: 'FacilityConfig',
          component: FacilityConfig,
          meta: {
            requiresAuth: true,
            link: '/Facility_Config'
          }
        },
        {
          path: '/AutoHandover_v1',
          name: 'AutoHandover_v1',
          component: AutoHandover_v1,
          meta: {
            requiresAuth: true,
            link: '/AutoHandover_v1'
          }
        },
        {
          path: '/AutoHandoverBarcode',
          name: 'AutoHandoverBarcode',
          component: AutoHandoverBarcode,
          meta: {
            requiresAuth: true,
            link: '/AutoHandoverBarcode'
          }
        },
        {
          path: '/AutoHandoverReports',
          name: 'AutoHandoverReports',
          component: AutoHandoverReports,
          meta: {
            requiresAuth: true,
            link: '/AutoHandoverReports'
          }
        },

        {
          path: '/AutoHandoverBatchDetailsPrint/:batchid/:currenthubid/:isEcom',
          name: 'AutoHandoverBatchDetailsPrint',
          component: AutoHandoverBatchDetailsPrint,
          meta: {
            requiresAuth: true,
            link: '/dashboard'
          }
        },

        {
          path: '/SectorMapping',
          name: 'SectorMapping',
          component: SectorMapping,
          meta: {
            requiresAuth: true,
            link: '/dashboard'
          }
        },
        {
          path: '/SorterConfig',
          name: 'SorterConfig',
          component: SorterConfig,
          meta: {
            requiresAuth: true,
            link: '/dashboard'
          }
        },
        {
          path: '/TrolleyConfig',
          name: 'TrolleyConfig',
          component: TrolleyConfig,
          meta: {
            requiresAuth: true,
            link: '/dashboard'
          }
        },
        {
          path: '/CameraConfig',
          name: 'CameraConfig',
          component: CameraMaster,
          meta: {
            requiresAuth: true,
            link: '/CameraConfig'
          }
        },
        {
          path: '/DockMaster',
          name: 'DockMaster',
          component: DockMaster,
          meta: {
            requiresAuth: true,
            link: '/dashboard'
          }
        },
        {
          path: '/ManualDockOut',
          name: 'ManualDockOut',
          component: ManualDockOut,
          meta: {
            requiresAuth: true,
            link: '/dashboard'
          }
        },
        {
          path: '/NtcMappingMaster',
          name: 'NtcMappingMaster',
          component: NtcMappingMaster,
          meta: {
            requiresAuth: true,
            link: '/dashboard'
          }
        },
        {
          path: '/NtcSectorMapping',
          name: 'NtcSectorMapping',
          component: NtcSectorMapping,
          meta: {
            requiresAuth: true,
            link: '/dashboard'
          }
        },
        {
          path: '/LmParentMapping',
          name: 'LmParentMapping',
          component: LmParentMapping,
          meta: {
            requiresAuth: true,
            link: '/LmParentMapping'
          }
        },
        {
          path: '/PickUPCenterConfig',
          name: 'PickUPCenterConfig',
          component: PickUPCenterConfig,
          meta: {
            requiresAuth: true,
            link: '/PickUPCenterConfig'
          }
        },
        {
          path: '/SorterPrintSticker',
          name: 'SorterPrintSticker',
          component: SorterPrintSticker,
          meta: {
            requiresAuth: true,
            link: '/dashboard'
          }
        },
         {
          path: '/DirectToBag',
          name: 'DirectToBag',
          component: DirectToBag,
          meta: {
            requiresAuth: true,
            link: '/dashboard'
          }
        },
        {
          path: '/shipmentsummary',
          name: 'shipmentsummary',
          component: shipmentsummary,
          meta: {
            requiresAuth: true,
            link: '/shipmentsummary'
          }
        },
        {
          path: '/confirmlinehaulconnection',
          name: 'confirmlinehaulconnection',
          component: confirmlinehaulconnection,
          meta: {
            requiresAuth: true,
            link: '/confirmlinehaulconnection'
          }
        },
        {
          path: '/connectionhubfornetwork',
          name: 'connectionhubfornetwork',
          component: connectionhubfornetworknew,
          meta: {
            requiresAuth: true,
            link: '/connectionhubfornetwork'
          }
        },
        {
          path: '/AWBVerificationDimWt',
          name: 'AWBVerificationDimWt',
          component: AWBVerificationDimWt_v1,
          meta: {
            requiresAuth: true,
            link: '/dashboard'
          }
        },
        {
          path: '/AWBVerificationDimWt_v1',
          name: 'AWBVerificationDimWt_v1',
          component: AWBVerificationDimWt_v1,
          meta: {
            requiresAuth: true,
            link: '/dashboard'
          }
        },
        // {
        //   path: '/AWBPendingVerification',
        //   name: 'AWBPendingVerification',
        //   component: AWBPendingVerification,
        //   meta: {
        //     requiresAuth: true,
        //     link: '/dashboard'
        //   }
        // },
        {
          path: '/ShipmentRuleDetails',
          name: 'ShipmentRuleDetails',
          component: ShipmentRuleDetails,
          meta: {
            requiresAuth: true,
            link: '/ShipmentRuleDetails'
          }
        },
        {
          path: '/SorterShipmentTracking',
          name: 'SorterShipmentTracking',
          component: SorterShipmentTracking,
          meta: {
            requiresAuth: true,
            link: '/SorterShipmentTracking'
          }
        },
        {
          path: '/HubDetails',
          name: 'HubDetails',
          component: hubparentbagginghubdetails,
          meta: {
            requiresAuth: true,
            link: '/HubDetails'
          }
        },
        // {
        //   path: '/hubparentbagginghubdetails',
        //   name: 'hubparentbagginghubdetails',
        //   component: hubparentbagginghubdetails,
        //   meta: {
        //     requiresAuth: true,
        //     link: '/dashboard'
        //   }
        // },
        {
          path: '/rtobagginghubdetails',
          name: 'rtobagginghubdetails',
          component: rtobagginghubdetails,
          meta: {
            requiresAuth: true,
            link: '/rtobagginghubdetails'
          }
        },
        {
          path: '/AllocateShipmentRuleToClient',
          name: 'AllocateShipmentRuleToClient',
          component: AllocateShipmentRuleToClient,
          meta: {
            requiresAuth: true,
            link: '/AllocateShipmentRuleToClient'
          }
        },
        {
          path: '/BulkAllocateShipmentRuleToClient',
          name: 'BulkAllocateShipmentRuleToClient',
          component: BulkAllocateShipmentRuleToClient,
          meta: {
            requiresAuth: true,
            link: '/dashboard'
          }
        },
        {
          path: '/BulkUploadSecondarySortConfiguration',
          name: 'BulkUploadSecondarySortConfiguration',
          component: BulkUploadSecondarySortConfiguration,
          meta: {
            requiresAuth: true,
            link: '/dashboard'
          }
        },
        {
          path: '/ConnectionHubDetailsRouteMode',
          name: 'ConnectionHubDetailsRouteMode',
          component: ConnectionHubDetailsRouteMode,
          meta: {
            requiresAuth: true,
            link: '/ConnectionHubDetailsRouteMode'
          }
        },
        {
          path: '/VehicleTripSummary',
          name: 'VehicleTripSummary',
          component: VehicleTripSummary,
          meta: {
            requiresAuth: true,
            link: '/VehicleTripSummary'
          }
        },
        {
          path: '/VehicleTripSummaryV1',
          name: 'VehicleTripSummaryV1',
          component: VehicleTripSummaryV1,
          meta: {
            requiresAuth: true,
            link: '/dashboard'
          }
        },
        {
          path: '/LineHaulPrint/:LineHaulDetailsID/:ConfirmLineHaulDetailsID',
          name: 'LineHaulPrint',
          component: LineHaulPrint,
          meta: {
            requiresAuth: true,
            link: '/confirmlinehaulconnection'
          }
        },
        {
          path: '/TripSheetPrint/:tripid/:currenthubid/:connectionschedulemasterid/:connectionid',
          name: 'TripSheetPrint',
          component: TripSheetPrint,
          meta: {
            requiresAuth: true,
            link: '/VehicleTripSummary'
          }
        },
        {
          path: '/TripSheetPrintV1/:tripid/:currenthubid/:connectionschedulemasterid/:connectionid',
          name: 'TripSheetPrintV1',
          component: TripSheetPrintV1,
          meta: {
            requiresAuth: true,
            link: '/dashboard'
          }
        },
        {
          path: '/BagDetailsInvoice',
          name: 'BagDetailsInvoice',
          component: BagDetailsInvoice,
          meta: {
            requiresAuth: true,
            link: '/BagDetailsInvoice'
          }
        },
        {
          path: '/StopPointHubAllocationMapping',
          name: 'StopPointHubAllocationMapping',
          component: StopPointHubAllocationMapping,
          meta: {
            requiresAuth: true,
            link: '/StopPointHubAllocationMapping'
          }
        },
        {
          path: '/LineHaulMaster',
          name: 'LineHaulMaster',
          component: LineHaulMaster,
          meta: {
            requiresAuth: true,
            link: '/dashboard'
          }
        },
        {
          path: '/EmployeeMaster',
          name: 'EmployeeMaster',
          component: EmployeeMaster,
          meta: {
            requiresAuth: true,
            link: '/dashboard'
          }
        },
        {
          path: '/DTOstickering',
          name: 'DTOstickering',
          component: DTOstickering,
          meta: {
            requiresAuth: true,
            link: '/dashboard'
          }
        },
        {
          path: '/PrintForwardSticker',
          name: 'PrintForwardSticker',
          component: PrintForwardSticker,
          meta: {
            requiresAuth: true,
            link: '/dashboard'
          }
        },
        {
          path: '/DlinkReport',
          name: 'DlinkReport',
          component: DlinkReport,
          meta: {
            requiresAuth: true,
            link: '/DlinkReport'
          }
        },
        {
          path: '/hubMachineConfiguration',
          name: 'hubMachineConfiguration',
          component: hubMachineConfiguration,
          meta: {
            requiresAuth: true,
            link: '/hubMachineConfiguration'
          }
        },
        {
          path: '/BagStickerPrint',
          name: 'BagStickerPrint',
          component: BagStickerPrint,
          meta: {
            requiresAuth: true,
            link: '/BagStickerPrint'
          }
        },
        {
          path: '/ShiftConnectionLHCO',
          name: 'ShiftConnectionLHCO',
          component: ShiftConnectionLHCO,
          meta: {
            requiresAuth: true,
            link: '/ShiftConnectionLHCO'
          }
        },
        {
          path: '/TripGenerateConnectionPrint/:CSMID/:connectiontype/:hubid',
          name: 'TripGenerateConnectionPrint',
          component: TripGenerateConnectionPrint,
          meta: {
            requiresAuth: true,
            link: '/BagDetailsInvoice'
          }
        },
        {
          path: '/AllocateHubToTouchPoint',
          name: 'AllocateHubToTouchPoint',
          component: AllocateHubToTouchPointForNetworkNew,
          meta: {
            requiresAuth: true,
            link: '/AllocateHubToTouchPoint'
          }
        },
        // {
        //   path: '/DWSInscan',
        //   name: 'DWSInscan',
        //   component: DWSInscan,
        // },
        {
          path: '/logs',
          name: 'LogDetails',
          component: LogDetails,
        },
        {
          path: '/CenterScanOut',
          name: 'CenterScanOut',
          component: CenterScanOut,
          meta: {
            requiresAuth: true,
            link: '/CenterScanOut'
          }
        },
        {
          path: '/BagOutShipment',
          name: 'BagOutShipment',
          component: BagOutShipment,
          meta: {
            requiresAuth: true,
            link: '/BagOutShipment'
          }
        },
        {
          path: '/CenterScanInTrip',
          name: 'CenterScanInTrip',
          component: CenterScanInTrip,
          meta: {
            requiresAuth: true,
            link: '/CenterScanInTrip'
          }
        },
        {
         path: '/CenterScanInTrip_v1',
         name: 'CenterScanInTrip_v1',
         component: CenterScanInTrip_v1,
         meta: {
           requiresAuth: true,
           link: '/dashboard'
         }
       },
        {
          path: '/BaginProcess',
          name: 'BaginProcess',
          component: BaginProcess,
          meta: {
            requiresAuth: true,
            link: '/BaginProcess'
          }
        },
        {
          path: '/BaginProcessWithRedis',
          name: 'BaginProcessWithRedis',
          component: BaginProcessWithRedis,
          meta: {
            requiresAuth: true,
            link: '/dashboard'
          }
        },
        {
          path: '/CreateRunSheet',
          name: 'Allocation',
          component: Allocation,
        },

        {
          path: '/NetworkManagement',
          name: 'Network Management',
          component: NetworkManagement,
          meta: {
            requiresAuth: true,
            link: '/NetworkManagement'
          }
        },
        {
          path: '/GenerateTripSheet',
          name: 'Generate Trip Sheet',
          component: GenerateTripSheet,
          meta: {
            requiresAuth: true,
            link: '/NetworkManagement'
          }
        },
        {
          path: '/HubInscan',
          name: 'HubInscan',
          component: HubInscan,
          meta: {
            requiresAuth: true,
            link: '/HubInscan'
          }
        },
        {
          path: '/GenerateVehicleTripPrint',
          name: 'Generate Vehicle Trip Print',
          component: GenerateVehicleTripPrint,
          meta: {
            requiresAuth: true,
            link: '/GenerateVehicleTripPrint'
          }
        },
        {
          path: '/binsticker',
          name: 'Bin Sticker',
          component: BinSticker,
          meta: {
            requiresAuth: true,
            link: '/binsticker'
          }
        },
        {
          path: '/PTLMappingList',
          name: 'PTL Mapping List',
          component: PTLMappingList,
          meta: {
            requiresAuth: true,
            link: '/dashboard'
          }
        },
        {
          path: '/BhiwandiSorter',
          name: 'Bhiwandi Sorter',
          component: BhiwandiSorter,
          meta: {
            requiresAuth: true,
            link: '/BhiwandiSorter'
          }
        },
        {
          path: '/PushCenterCode',
          name: 'PushCenterCode',
          component: PushCenterCode,
          meta: {
            requiresAuth: true,
            link: '/PushCenterCode'
          }
        },
        {
          path: '/PushBaginRule',
          name: 'PushBaginRule',
          component: PushBaginRule,
          meta: {
            requiresAuth: true,
            link: '/PushBaginRule'
          }
        },
        {
          path: '/UnboxSurat',
          name: 'Unbox Surat',
          component: UnboxSurat,
          meta: {
            requiresAuth: true,
            link: '/UnboxSurat'
          }
        },
        {
          path: '/SuratCBS',
          name: 'SuratCBS',
          component: SuratCBS,
          meta: {
            requiresAuth: true,
            link: '/SuratCBS'
          }
        },
        {
          path: '/bangloreCBS',
          name: 'bangloreCBS',
          component: bangloreCBS,
          meta: {
            requiresAuth: true,
            link: '/bangloreCBS'
          }
        },
        {
          path: '/ArmstrongCBS',
          name: 'ArmstrongCBS',
          component: ArmstrongCBS,
          meta: {
            requiresAuth: true,
            link: '/ArmstrongCBS'
          }
        },
        {
          path: '/chennaiSorter',
          name: 'chennaiSorter',
          component: ChennaiSorter,
          meta: {
            requiresAuth: true,
            link: '/ChennaiSorter'
          }
        },
        {
          path: '/DNFShipmentReport',
          name: 'DNFShipmentReport',
          component: DNFShipmentReport,
          meta: {
            requiresAuth: true,
            link: '/DNFShipmentReport'
          }
        },
        {
          path: '/PushShipmentDetails',
          name: 'PushShipmentDetails',
          component: PushShipmentDetails,
          meta: {
            requiresAuth: true,
            link: '/PushShipmentDetails'
          }
        },
        {
          path: '/RVPPrintLabel',
          name: 'RVPPrintLabel',
          component: dashboard,
          meta: {
            requiresAuth: true,
            link: '/RVPPrintLabel'
          }
        },
        {
          path: '/RTODTOLabel',
          name: 'RTODTOLabel',
          component: RTODTOLabel,
          meta: {
            requiresAuth: true,
            link: '/RTODTOLabel'
          }
        },
        {
          path: '/RTODTOLabelNew',
          name: 'DTOStickerPrintLable',
          component: RTODTOLabelNew,
          meta: {
            requiresAuth: true,
            link: '/dashboard'
          }
        },
        {
          path: '/AWBFlyerMatchCheck',
          name: 'DTOAWBFlyerCheck',
          component: DTOAWBFlyerCheck,
          meta: {
            requiresAuth: true,
            link: '/dashboard'
          }
        },
        {
          path: '/Downloads3bucketfiles',
          name: 'Downloads3bucketfiles',
          component: Downloads3bucketfiles,
          meta: {
            requiresAuth: true,
            link: '/dashboard'
          }
        },
        {
          path: '/MarkBulkBagShortage',
          name: 'MarkBulkBagShortage',
          component: MarkBulkBagShortage,
          meta: {
            requiresAuth: true,
            link: '/dashboard'
          }
        },
        {
          path: '/RTODTOStickerTracking',
          name: 'RTODTOStickerTracking',
          component: RTODTOStickerTracking,
          meta: {
            requiresAuth: true,
            link: '/dashboard'
          }
        },
        {
          path: '/SorterImageDownload',
          name: 'Sorter Image Download',
          component: SorterImageDownload,
          meta: {
            requiresAuth: true,
            link: '/dashboard'
          }
        },
        {
          path: '/TripSheetPrintFromCurrentTP/:tripid/:currenthubid/:connectionschedulemasterid/:connectionid',
          name: 'Trip Sheet Print From Current TP',
          component: TripSheetPrintFromCurrentTP,
          meta: {
            requiresAuth: true,
            link: '/VehicleTripSummary'
          }
        },
        {
          path: '/TripSheetPrintFromCurrentTPV1/:tripid/:currenthubid/:connectionschedulemasterid/:connectionid',
          name: 'Trip Sheet Print From Current TP V1',
          component: TripSheetPrintFromCurrentTPV1,
          meta: {
            requiresAuth: true,
            link: '/dashboard'
          }
        },
        {
          path: '/TripSheetPrintForBulkFromCurrentTP/:tripid/:currenthubid/:connectionschedulemasterid/:connectionid',
          name: 'Trip Sheet Print Bulk From Current TP',
          component: TripSheetPrintForBulkFromCurrentTP,
          meta: {
            requiresAuth: true,
            link: '/VehicleTripSummary'
          }
        },
        {
          path: '/TripSheetPrintForBulkFromCurrentTPV1/:tripid/:currenthubid/:connectionschedulemasterid/:connectionid',
          name: 'Trip Sheet Print Bulk From Current TP V1',
          component: TripSheetPrintForBulkFromCurrentTPV1,
          meta: {
            requiresAuth: true,
            link: '/dashboard'
          }
        },
        {
          path: '/SorterSQSDetails',
          name: 'SorterSQSDetails',
          component: SorterSQSDetails,
          meta: {
            requiresAuth: true,
            link: '/dashboard'
          }
        },
        {
          path: '/PalletizationMasters',
          name: 'PalletizationMasters',
          component: PalletizationMasters,
          meta: {
            requiresAuth: true,
            link: '/PalletizationMasters'
          }
        },
        {
          path: '/PalletizationReports',
          name: 'PalletizationReports',
          component: PalletizationReports,
          meta: {
            requiresAuth: true,
            link: '/PalletizationReports'
          }
        },
        {
          path: '/PalletizationBarcode',
          name: 'PalletizationBarcode',
          component: PalletizationBarcode,
          meta: {
            requiresAuth: true,
            link: '/PalletizationBarcode'
          }
        },
        {
          path: '/ReleasePrinter',
          name: 'ReleasePrinter',
          component: ReleasePrinter,
          meta: {
            requiresAuth: true,
            link: '/ReleasePrinter'
          }
        },
        
        {
          name: 'Audit SVC ExecutionList',
          path: '/AuditSVCExecutionList',
          beforeEnter() {
            window.open("http://admin.xpressbees.com/Audit/OperationSC/OperationSCExecutionList.aspx", '_blank');
          }
        },


        {
          name: 'Audit Hub ExecutionList',
          path: '/AuditHubExecutionList',
          beforeEnter() {
            window.open("http://admin.xpressbees.com/Audit/OperationHub/OperationHubExecutionList.aspx", '_blank');
          }
        },

        {
          name: 'Audit Finance ExecutionList',
          path: '/AuditFinanceExecutionList',
          beforeEnter() {
            window.open("http://admin.xpressbees.com/Audit/Finance/AuditFinanceExecutionList.aspx", '_blank');
          }
        },
        {
          name: 'Audit HR ExecutionList',
          path: '/AuditHRExecutionList',
          beforeEnter() {
            window.open("http://admin.xpressbees.com/Audit/HR/HRExecutionList.aspx", '_blank');
          }
        }, {
          name: 'Audit HRAdmin ExecutionList',
          path: '/AuditHRAdminExecutionList',
          beforeEnter() {
            window.open("http://admin.xpressbees.com/Audit/HRAdmin/HRAdminExecutionList.aspx", '_blank');
          }
        }, {
          name: 'Audit ITHardware ExecutionList',
          path: '/AuditITHardwareExecutionList',
          beforeEnter() {
            window.open("http://admin.xpressbees.com/Audit/ITHardware/ITHardwareExecutionList.aspx", '_blank');
          }
        }, {
          name: 'Audit ITSoftware ExecutionList',
          path: '/AuditITSoftwareExecutionList',
          beforeEnter() {
            window.open("http://admin.xpressbees.com/CustomErrorPage.html?aspxerrorpath=/Audit/ITSoftware/ITSoftwareExecutionList.aspx", '_blank');
          }
        }, {
          name: 'Audit Security ExecutionList',
          path: '/AuditSecurityExecutionList',
          beforeEnter() {
            window.open("http://admin.xpressbees.com/CustomErrorPage.html?aspxerrorpath=/Audit/Security/SecurityExecutionList.aspx", '_blank');
          }
        }, {
          name: 'Audit Plan Report',
          path: '/AuditPlanReport',
          beforeEnter() {
            window.open("http://admin.xpressbees.com/audit/Auditplanreport.aspx", '_blank');
          }
        },

        {
          path: '/Sorter',
          name: 'Sorter',
          component: Sorter,
          meta: {
            requiresAuth: true,
            link: '/Sorter'
          }
        },
        {
          path: '/InscanOverageShortage',
          name: 'InscanOverageShortage',
          component: InscanOverageShortage,
          meta: {
            requiresAuth: true,
            link: '/InscanOverageShortage'
          }
        },

        {
          path: '/changepassword',
          name: 'changepassword',
          component: changepassword,
          meta: {
            requiresAuth: true,
            link: '/changepassword'
          }
        },
        {
          path: '/AdditionalEventLogs',
          name: 'AdditionalEventLogs',
          component: AdditionalEventLogs,
          meta: {
            requiresAuth: true,
            link: '/dashboard'
          }
        },
        {
          path: '/BagShipmentQuery',
          name: 'BagShipmentQuery',
          component: BagShipmentQuery,
          meta: {
            requiresAuth: true,
            link: '/BagShipmentQuery'
          }
        },
        {
          path: '/SRTripDayClosure',
          name: 'SRTripDayClosure',
          component: SRTripDayClosure,
          meta: {
            requiresAuth: true,
            link: '/SRTripDayClosure'
          }
        },
        {
          path: '/MarkHubStressed',
          name: 'MarkHubStressed',
          component: MarkHubStressed,
          meta: {
            requiresAuth: true,
            link: '/MarkHubStressed'
          }
        },
        {
          path: '/TransactionalLogs',
          name: 'TransactionalLogs',
          component: TransactionalLogs,
          meta: {
            requiresAuth: true,
            link: '/TransactionalLogs'
          }
        },
        {
          path: '/LineHaulStatusCode',
          name: 'LineHaulStatusCode',
          component: LineHaulStatusCode,
          meta: {
            requiresAuth: true,
            link: '/LineHaulStatusCode'
          }
        },
        {
          path: '/MissingShipmentLogReconcile',
          name: 'MissingShipmentLogReconcile',
          component: MissingShipmentLogReconcile,
          meta: {
            requiresAuth: true,
            link: '/MissingShipmentLogReconcile'
          }
        },
        {
          path: '/SurfaceCargoMapping',
          name: 'SurfaceCargoMapping',
          component: SurfaceCargoMapping,
          meta: {
            requiresAuth: true,
            link: '/SurfaceCargoMapping'
          }
        },
        {
          path: '/changeBagSeal',
          name: 'changeBagSeal',
          component: changeBagSeal,
          meta: {
            requiresAuth: true,
            link: '/changeBagSeal'
          }
        },
        {
          path: '/locationMaster',
          name: 'locationMaster',
          component: locationMaster,
          meta: {
            requiresAuth: true,
            link: '/dashboard'
          }
        },
        {
          path: '/rackMaster',
          name: 'rackMaster',
          component: rackMaster,
          meta: {
            requiresAuth: true,
            link: '/dashboard'
          }
        },
        {
          path: '/palletMaster',
          name: 'palletMaster',
          component: palletMaster,
          meta: {
            requiresAuth: true,
            link: '/dashboard'
          }
        },
        {
          path: '/rowMaster',
          name: 'rowMaster',
          component: rowMaster,
          meta: {
            requiresAuth: true,
            link: '/dashboard'
          }
        },
        {
          path: '/binsMaster',
          name: 'binsMaster',
          component: binsMaster,
          meta: {
            requiresAuth: true,
            link: '/dashboard'
          }
        },
        {
          path: '/TripManagement',
          name: 'TripManagement',
          component: TripManagement,
          meta: {
            requiresAuth: true,
            link: '/TripManagement'
          }
        },
        {
          path: '/combohubdetails',
          name: 'combohub',
          component: combohub,
          meta: {
            requiresAuth: true,
            link: '/combohubdetails'
          }
        },
        {
          path: '/ComboHubBagShortageMark',
          name: 'ComboHubBagShortageMark',
          component: ComboHubBagShortageMark,
          meta: {
            requiresAuth: true,
            link: '/ComboHubBagShortageMark'
          }
        },
        {
          path: '/combohubconfiguration',
          name: 'combohubconfiguration',
          component: combohubconfiguration,
          meta: {
            requiresAuth: true,
            link: '/combohubconfiguration'
          }
        },
        {
          path: '/markshipmentshortage',
          name: 'MarkShipmentShortage',
          component: MarkShipmentShortage,
          meta: {
            requiresAuth: true,
            link: '/markshipmentshortage'
          }
        },
        {
          path: '/RVPLabel',
          name: 'RVPLabel',
          component: RVPLabel,
          meta: {
            requiresAuth: true,
            link: '/RVPLabel'
          }
        },
        {
          path: '/AllocateActiveHub',
          name: 'AllocateActiveHub',
          component: AllocateActiveHub,
          meta: {
            requiresAuth: true,
            link: '/AllocateActiveHub'
          }
        },
        {
          path: '/ProcessCodeGeneration',
          name: 'ProcesscodeGeneration',
          component: ProcesscodeGeneration,
          meta: {
            requiresAuth: true,
            link: '/dashboard'
          }
        },
        {
          path: '/BagDetailsByHub',
          name: 'BagDetailsByHub',
          component: BagDetailsByHub,
          meta: {
            requiresAuth: true,
            link: '/BagDetailsByHub'
          }
        },
        {
          path: '/AutoBagOutHubConfiguration',
          name: 'AutoBagOutHubConfiguration',
          component: AutoBagOutHubConfiguration,
          meta: {
            requiresAuth: true,
            link: '/AutoBagOutHubConfiguration'
          }
        },
        {
          path: '/AutoBagOutConfiguration_v1',
          name: 'AutoBagOutConfiguration_v1',
          component: AutoBagOutConfiguration_v1,
          meta: {
            requiresAuth: true,
            link: '/dashboard'
          }
        },
        {
          path: '/AddDamageByOperation',
          name: 'AddDamageByOperation',
          component: AddDamageByOperation,
          meta: {
            requiresAuth: true,
            link: '/dashboard'
          }
        },
        {
          path: '/InscanNTSShipment',
          name: 'InscanNTSShipment',
          component: InscanNTSShipment,
          meta: {
            requiresAuth: true,
            link: '/InscanNTSShipment'
          }
        },

        {
          path: '/FetchConnectionDetails',
          name: 'FetchConnectionDetails',
          component: FetchConnectionDetails,
          meta: {
            requiresAuth: true,
            link: '/FetchConnectionDetails'
          }
        },
        {
          path: '/OffloadShipment',
          name: 'OffloadShipment',
          component: OffloadShipment,
          meta: {
            requiresAuth: true,
            link: '/OffloadShipment'
          }
        },
        {
          path: '/THCQuerySummary',
          name: 'THCQuerySummary',
          component: THCQuerySummary,
          meta: {
            requiresAuth: true,
            link: '/dashboard'
          }
        },
        {
          path: '/ShipmentClientRule',
          name: 'ShipmentClientRule',
          component: ShipmentClientRule,
          meta: {
            requiresAuth: true,
            link: '/shipmentclientrule'
          }
        },
        {
          path: '/DTOProcessingHubDetails',
          name: 'DTOProcessingHubDetails',
          component: DTOProcessingHubDetails,
          meta: {
            requiresAuth: true,
            link: '/DTOProcessingHubDetails'
          }
        },
        {
          path: '/pushNDCDetails',
          name: 'pushNDCDetails',
          component: pushNDCDetails,
          meta: {
            requiresAuth: true,
            link: '/dashboard'
          }
        },
        {
          path: '/AWBVerification',
          name: 'AWBVerification',
          component: AWBPendingVerification,
          meta: {
            requiresAuth: true,
            link: '/awbverification'
          }
        },
        {
          path: '/AWBVerificationMapping',
          name: 'AWBVerificationMapping',
          component: AWBVerificationMapping,
          meta: {
            requiresAuth: true,
            link: '/AWBVerificationMapping'
          }
        },
        {
          path: '/CloseBin',
          name: 'CloseBin',
          component: CloseBin,
          meta: {
            requiresAuth: true,
            link: '/dashboard'
          }
        },
        {
          path: '/ScanToBagReport',
          name: 'ScanToBagReport',
          component: ScanToBagReport,
          meta: {
            requiresAuth: true,
            link: '/dashboard'
          }
        },
        {
          path: '/bagStatusReport',
          name: 'bagAndShipmentStatusReport',
          component: bagAndShipmentStatusReport,
          meta: {
            requiresAuth: true,
            link: '/dashboard'
          }
        },
        {
          path: '/unlinkMultiPartGrpId',
          name: 'unlinkMultiPartGrpId',
          component: unlinkMultiPartGrpId,
          meta: {
            requiresAuth: true,
            link: '/dashboard'
          }
        },
        {
          path: '/mergeConnectionSchedule',
          name: 'mergeConnectionSchedule',
          component: mergeConnectionSchedule,
          meta: {
            requiresAuth: true,
            link: '/dashboard'
          }
        },
        {
          path: '/generateBagOctroilListPrint/:CSMID/:hubid',
          name: 'generateBagOctroilListPrint',
          component: generateBagOctroilListPrint,
          meta: {
            requiresAuth: true,
            link: '/BagDetailsInvoice'
          }
        },
        {
          path: '/ScanToBagActiveBinReport',
          name: 'ScanToBagActiveBinReport',
          component: ScanToBagActiveBinReport,
          meta: {
            requiresAuth: true,
            link: '/dashboard'
          }
        },
        {
          path: '/DelhiSorter',
          name: 'DelhiSorter',
          component: DelhiSorter,
          meta: {
            requiresAuth: true,
            link: '/DelhiSorter'
          }
        },
        {
          path: '/ebnShipmentDetails',
          name: 'ebnShipmentDetails',
          component: EbnShipmentDetails,
          meta: {
            requiresAuth: true,
            link: '/dashboard'
          }
        },
        {
          path: '/PalletReportPages',
          name: 'PalletReportPages',
          component: PalletReportPages,
          meta: {
            requiresAuth: true,
            link: '/dashboard'
          }
        },
        {
          path: '/PTLMapping',
          name: 'PTLMapping',
          component: PTLMapping,
          meta: {
            requiresAuth: true,
            link: '/dashboard'
          }
        },
        {
         path: '/InscanDoneBagInPendingReport',
         name: 'InscanDoneBagInPendingReport',
         component: InscanDoneBagInPendingReport,
         meta: {
           requiresAuth: true,
           link: '/dashboard'
         }
        },
        {
          path: '/SorterBatchStatus',
          name: 'SorterBatchStatus',
          component: SorterBatchStatus,
          meta: {
            requiresAuth: true,
            link: '/dashboard'
          }
        },
        {
          path: '/DWSInscanNew',
          name: 'DWSInscanNew',
          component: DWSInscanNew,
          meta: {
            requiresAuth: true,
            link: '/DWSInscanNew'
          }
        },
        {
         path: '/MandatoryWeighingEventConfig',
         name: 'MandatoryWeighingEventConfig',
         component: MandatoryWeighingEventConfig,
         meta: {
           requiresAuth: true,
           link: '/dashboard'
         }
       },
        {
         path: '/RestrictTempInscanOnHub',
         name: 'RestrictTempInscanOnHub',
         component: RestrictTempInscanOnHub,
         meta: {
           requiresAuth: true,
           link: '/dashboard'
         }
       },
      {
         path: '/ExportRestrictTempInscanMapping',
         name: 'ExportRestrictTempInscanMapping',
         component: ExportRestrictTempInscanMapping,
         meta: {
           requiresAuth: true,
           link: '/dashboard'
         }
       },
        {
         path: '/InboundMandate',
         name: 'InboundMandate',
         component: InboundMandate,
         meta: {
           requiresAuth: true,
           link: '/dashboard'
         }
       },
       {
        path: '/FalconSorter',
        name: 'FalconSorter',
        component: FalconSorter,
        meta: {
          requiresAuth: true,
          link: '/FalconSorter'
        }
      },
      {
        path: '/BagSorter',
        name: 'BagSorter',
        component: BagSorter,
        meta: {
          requiresAuth: true,
          link: '/BagSorter'
        }
      },
      {
        path: '/KengicSorter',
        name: 'KengicSorter',
        component: KengicSorter,
        meta: {
          requiresAuth: true,
          link: '/KengicSorter'
        }
      },
      {
        path: '/SorterHandover',
        name: 'SorterHandover',
        component: SorterHandover,
        meta: {
          requiresAuth: true,
          link: '/SorterHandover'
        }
      },
      {
        path: '/groupnew',
        name: 'groupnew',
        component: groupnew,
        meta: {
          requiresAuth: true,
          link: '/dashboard'
        }
      },
      {
        path: '/groupdestinationsearch',
        name: 'groupdestinationsearch',
        component: groupdestinationsearch,
        meta: {
          requiresAuth: true,
          link: '/dashboard'
        }
      },
      {
        path: '/VehicleSealInScan',
        name: 'VehicleSealInScan',
        component: VehicleSealInScan,
        meta: {
          requiresAuth: true,
          link: '/dashboard'
        }
      },
      {
        path: '/SorterBagging',
        name: 'SorterBagging',
        component: SorterBagging,
        meta: {
          requiresAuth: true,
          link: '/dashboard'
        }
      },
       {
        path: '/RedisDashboard',
        name: 'RedisDashboard',
        component: RedisDashboard,
        meta: {
          requiresAuth: true,
          link: '/dashboard'
        }
      },
      {
        path: '/ProductivityTracking',
        name: 'ProductivityTracking',
        component: ProductivityTracking,
        meta: {
          requiresAuth: true,
          // Uses dashboard permission until UMS menu url `/ProductivityTracking` is assigned
          link: '/dashboard'
        }
      },
        {
          path: '/import',
          name: 'import',
          component: Import,
          meta: {
            requiresAuth: true,
            breadcrumb: [{
                name: 'Home',
                link: '/import'
              },
              {
                name: 'Import'
              }
            ]
          }
        },
        {
          path: 'charts',
          name: 'Charts',
          component: Charts
        },
        {
          path: 'widgets',
          name: 'Widgets',
          component: Widgets
        },

        {
          path: 'icons',
          redirect: '/icons/font-awesome',
          name: 'Icons',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [{
              path: 'font-awesome',
              name: 'Font Awesome',
              component: FontAwesome
            },
            {
              path: 'simple-line-icons',
              name: 'Simple Line Icons',
              component: SimpleLineIcons
            }
          ]
        }
      ]
    },

    {
      path: '/login/:token?',
      name: 'login',
      component: Login
    },
    
    {
      path: '/pages',
      redirect: '/pages/p404',
      name: 'Pages',
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [{
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        },
        {
          path: 'login',
          name: 'Login',
          component: Login
        },
        {
          path: 'register',
          name: 'Register',
          component: Register
        }
      ]
    },

  ]
});


router.beforeEach((to, from, next) => {  
  if (to.path.startsWith('/fonts') || to.path.startsWith('/static')) {
    next({
      path: "/login",

    });
  } else {
      next();
  }
});

router.beforeEach((to, from, next) => {
  if (to.matched.length <= 0) {
    return false;
  } else {
    next()
  }

  var isLoggedIn = window.localStorage.getItem('isLoggedIn');
  if (isLoggedIn == null) {
    isLoggedIn = false;
  } else {
    isLoggedIn = true;
  }
  //console.log(to.meta.link);
  if (to.matched.some(record => record.meta.requiresAuth) && !isLoggedIn) {
    next({
      path: "/login",

    });
  } else {
    if (isLoggedIn) {
      if (to.meta.link == "/changehub" || to.meta.link == "/changepassword" || to.meta.link == "/ProductivityTracking") {
        next();
      } else {
        // console.log(to.meta.adminAuth);
        var setrole = false;
        const role = window.localStorage.getItem('role');
        var permissionEncrypt = window.localStorage.getItem('permissiondata')
        var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        var permissiondata = JSON.parse(plaintext);
        //console.log(permissiondata);
        for (var i = 0; i < permissiondata.length; i++) {
          if (permissiondata[i].children.length > 0) {
            //Means SUb Menu Exists
            for (var k = 0; k < permissiondata[i].children.length; k++) {
              if (permissiondata[i].children[k].url == to.meta.link) {
                setrole = true;
                break;
              }

            }
            if (setrole == true) {
              break;
            }
          } else {
            if (permissiondata[i].url == to.meta.link) {
              setrole = true;
              break;
            } else {
              setrole = false
            }
          }
        } //END I Loop
        if (setrole) {
          next();
        } else {
          next({
            path: "/dashboard",
          });
        }
      }
    } else {
      next();
    }
  }

});


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js